import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { selectOrganizationId } from '../../store/slices/auth.slice';

export const useOrganizationId = () => {
    return useSelector<RootState, string>(selectOrganizationId);
};
